<template>
    <DropdownMenuItem v-bind="forwardedProps" :class="dropdownMenuItemClass">
        <slot />
    </DropdownMenuItem>
</template>
<script setup lang="ts">
import { type HTMLAttributes, computed } from "vue";
import { DropdownMenuItem, type DropdownMenuItemProps, useForwardProps } from "reka-ui";

const props = defineProps<DropdownMenuItemProps & { class?: HTMLAttributes["class"]; inset?: boolean }>();

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);

const DROPDOWN_MENU_ITEM_CLASS =
    "relative flex text-gray-800 hover:text-gray-800 hover:no-underline cursor-pointer select-none items-center rounded-xs py-3 px-6 text-sm outline-hidden transition-colors focus:bg-gray-100 focus:text-gray-900 data-[disabled]:pointer-events-none data-[disabled]:opacity-50";
const dropdownMenuItemClass = computed(() => cn(DROPDOWN_MENU_ITEM_CLASS, props.inset && "pl-8", props.class));
</script>
